module.exports = __webpack_public_path__ + "static/media/21_Maf_NuestroEquipo_CarlosElizarraraz.bd8a75fb.jpg";